<div id="loader-wrapper" *ngIf="isVisible">
    <div class="wrapper">
        <img class="loader-image" src="/assets/spinner/images/loadingSpinner.gif" alt="loading spinner" />
        <p class="loader-text">Loading...</p>
    </div>
</div>